export default [
    {
      fileName: "client/banner_emi.jpg",
      link: "https://emi.ro/servicii/",
      category: "Banner",
      action: "Click",
      label: "Afiliat_Emi",
    },
    {
      fileName: "client/banner_kadra.jpg",
      link: "https://kadra.ro/service-si-mentenanta/",
      category: "Banner",
      action: "Click",
      label: "Afiliat_Kdra",
    },
    {
    fileName: "client/banner_recommend_3.jpg",
    link: "https://upromania.ro/utilizatori/recomanda-si-castiga/",
    category: "Banner",
    action: "Click",
    label: "Afiliat_Recomanda",
  },
];
